import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightCaramel = () => {
  return (
    <div className="blogWhat-content">
      <h5>2. Caramel Balayage for a Sun-Kissed Glow ☀️</h5>
      <p>
        If you're looking for a warm and natural vibe, caramel balayage is the
        perfect choice. This hair highlights color blends seamlessly with dark
        brown or black hair, giving it a sun-kissed, effortless effect. The
        technique involves painting on highlights, creating a natural and
        blended look.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" /> Requires minimal maintenance{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Adds warmth and brightness
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" /> Looks good on all skin tones
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightCaramel;
